/** `GET /directory` (workers/api/src/staff/directory.ts): the business's people for name lookups, redacted by lever. Any active staff may call it. */
import type { ApiClient } from "./client";

export interface DirectoryEntry {
  id: string;
  /** Null unless the caller holds `staff.see_names`, or `staff.see_trainer_names` and this person is a trainer (D57). */
  name: string | null;
  isTrainer: boolean;
  active: boolean;
}

export const getDirectory = (c: ApiClient) => c.get<{ staff: DirectoryEntry[] }>("/directory").then((r) => r.staff);
